/** 施設CRUD後、一覧だけでなくワークスペースの選択肢も更新する。 */
export const FACILITIES_UPDATED_EVENT = "facilities-updated";

export function notifyFacilitiesUpdated() {
  window.dispatchEvent(new Event(FACILITIES_UPDATED_EVENT));
}
